import React from "react"
import "./HomeSlider.css"
import { connect } from "react-redux"

// Only videos that are still public and embeddable on YouTube
const VIDEOS = [
  { id: "bSsQPeHvczU", title: "Love Potion video" },
  { id: "lFYUCe2fu3I", title: "Monarque video" },
]

const HomeCategory = ({ translation }) => {
  return (
    <section className="HomeCategory Container">
      <div className="Home--video">
        <h2 className="Section--title">
          {translation.language === "ua" ? "Відео з нашого YouTube-каналу" : "Видео с нашего YouTube-канала"}
        </h2>
        <div className="youtube--videos">
          {VIDEOS.map(video => (
            <div className="youtube--video" key={video.id}>
              <iframe
                title={video.title}
                src={`https://www.youtube.com/embed/${video.id}`}
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

const mapStateToProps = state => {
  return {
    translation: state.translationReducer,
  }
}

export default connect(mapStateToProps)(HomeCategory)
